var _path, _path2, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnAdult = function SvgIcnAdult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.503 0.397599C7.79356 0.165149 8.20644 0.165149 8.497 0.397599C9.82683 1.46146 11.2878 2.35013 12.844 3.04178L14.5557 3.80251C14.822 3.92089 14.9849 4.1942 14.9623 4.48479L14.5571 9.69864C14.4296 11.3397 13.5025 12.8128 12.0782 13.6378L8.50121 15.7097C8.1912 15.8893 7.8088 15.8893 7.49879 15.7097L3.9218 13.6378C2.49749 12.8128 1.57044 11.3397 1.4429 9.69864L1.03768 4.48479C1.01509 4.1942 1.178 3.92089 1.44435 3.80251L3.15599 3.04178C4.71222 2.35013 6.17317 1.46146 7.503 0.397599Z",
    fill: "#FF970C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25585_123448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 15,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09546 4.17232C1.04103 3.72464 1.33049 3.30714 1.76883 3.20109L3 2.90323C4.32202 2.58338 5.5738 2.02272 6.69267 1.24931L7.9511 0.379422C8.28142 0.151094 8.71858 0.151094 9.0489 0.379422L10.3073 1.24931C11.4262 2.02272 12.678 2.58338 14 2.90323L15.2312 3.20109C15.6695 3.30714 15.959 3.72464 15.9045 4.17232L15.2542 9.52179C15.0951 10.8307 14.3012 11.977 13.1319 12.5863L9.01346 14.7324C8.69169 14.9001 8.30831 14.9001 7.98654 14.7324L5.25 13.3065L3.86809 12.5864C2.69881 11.977 1.9049 10.8307 1.74579 9.52179L1.09546 4.17232Z",
    fill: "#FF970C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25585_123448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95459 8.24368C9.05916 8.24368 9.95459 7.36453 9.95459 6.28004C9.95459 5.19556 9.05916 4.31641 7.95459 4.31641C6.85002 4.31641 5.95459 5.19556 5.95459 6.28004C5.95459 7.36453 6.85002 8.24368 7.95459 8.24368ZM11.6938 11.1156C12.0719 11.4611 11.9231 12.0382 11.4796 12.2944L8.45484 14.0419C8.14531 14.2207 7.76387 14.2207 7.45435 14.0419L4.43007 12.2947C3.98646 12.0384 3.83758 11.4612 4.21577 11.1156C5.24128 10.1784 6.54093 9.61823 7.9548 9.61823C9.36867 9.61823 10.6683 10.1784 11.6938 11.1156ZM8.53673 15.3595L9.41891 14.8733C10.8001 14.1122 11.8668 15.1439 10.4682 15.8725C9.72919 16.2575 8.85844 16.491 7.9548 16.491C7.05141 16.491 6.18089 16.2576 5.44203 15.8728C4.04326 15.1443 5.10984 14.1127 6.4911 14.8738L7.37245 15.3595C7.73446 15.559 8.17472 15.559 8.53673 15.3595Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnAdult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_adult.c9430fec.svg";
export { ForwardRef as ReactComponent };